<template>
	<div class="el-input">

		<input
				class="el-input__inner"
				autocomplete="off"
				type="text"
				rows="2"
				validateevent="true"
				:maxlength="maxLength"
				v-model="displayValue"
				:disabled="disabled"
				:placeholder="placeholder"


				@focus="handleFocus"
				@blur="handleBlur"
				@change="handleChange"
		>
	</div>
</template>
<script type="text/javascript">

	export default {
		props: ['value','disabled','placeholder','maxLength'],
		data: function() {
			return {
				isInputActive: false
			}
		},
		computed: {
			displayValue: {
				get: function() {
					var value = this.value ? this.value:'';
					if (this.isInputActive) {
						// Cursor is inside the input field. unformat display value for user
						return value.toString()
					} else {
						// User is not modifying now. Format display value for user interface
						return  isNaN(value) === true ? value.replace(/[^\d]/g,'') : value;
					}
				},
				set: function(modifiedValue) {
					// Recalculate value after ignoring "$" and "," in user input
					let newValue =  modifiedValue.replace(/[^\d]/g,'');
					// Ensure that it is not NaN
					if (isNaN(newValue)) {
						newValue = null
					}
					// Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
					// $emit the event so that parent component gets it
					this.$emit('input', newValue);
					this.dispatch('ElFormItem', 'el.form.change', [newValue]);
				}
			}
		},
		methods: {
			handleFocus(event) {
				this.isInputActive = true;
				this.$emit('focus', event);
			},
			handleBlur(event) {
				this.isInputActive = false;
				this.$emit('blur', event);
				this.dispatch('ElFormItem', 'el.form.blur', [this.value]);

			},
			dispatch(componentName, eventName, params) {
				var parent = this.$parent || this.$root;
				var name = parent.$options.componentName;

				while (parent && (!name || name !== componentName)) {
					parent = parent.$parent;

					if (parent) {
						name = parent.$options.componentName;
					}
				}
				if (parent) {
					parent.$emit.apply(parent, [eventName].concat(params));
				}
			},
			handleChange(event) {
				this.$emit('change', event.target.value);
			},
		}
	}
</script>
